[<template>
  <div>
    <el-table
      :data="claimsPrivate.data"
      :default-sort="{ prop: order_column, order: order_type }"
      class="w100"
      stripe
      v-loading="loading"
    >
      <el-table-column
        label="Label"
        prop="label"
        sortable
        width="150%"
      ></el-table-column>
      <el-table-column label="Channel name" prop="channelId" sortable>
        <template slot-scope="props">
          <a
            :href="`https://youtube.com/channel/${props.row.channelId}`"
            target="_blank"
            v-if="props.row.channelId"
          >
            {{ props.row.channelId }}
          </a>
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="Video" prop="title" sortable>
        <template slot-scope="props">
          <a
            :href="`https://youtube.com/watch?v=${props.row.id}`"
            target="_blank"
            v-if="props.row.id"
          >
            {{ props.row.title }}
          </a>
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="Asset" prop="asset" sortable></el-table-column>
      <el-table-column label="Video published at" prop="published_at" sortable>
        <template slot-scope="props">
          {{ props.row.published_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Type" prop="type" sortable>
        <template slot-scope="props">
          <el-tag v-if="props.row.type == 'Private'" type="danger">
            {{ props.row.type }}
          </el-tag>
          <el-tag v-else type="success">
            {{ props.row.type }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Status" prop="status" sortable></el-table-column>
      <el-table-column label="License" prop="license" sortable>
        <template slot-scope="props">
          <el-tag v-if="props.row.license == 'Yes'" type="success">
            {{ props.row.license }}
          </el-tag>
          <el-tag v-else type="danger">
            {{ props.row.license }}
          </el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="Description"
        prop="description"
        sortable
      ></el-table-column> -->
      <el-table-column label="Actions" align="right" width="100%">
        <template slot-scope="props">
          <el-tooltip content="Release claim" placement="right">
            <el-button
              v-if="props.row.type == 'Public' && props.row.license == 'Yes'"
              type="success"
              circle
              size="small"
              icon="el-icon-check"
              @click="release(props.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        class="float-right"
        background
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="claimsPrivate.current_page"
        :page-sizes="[5, 10, 25, 50, 100]"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="claimsPrivate.total"
    ></el-pagination>
  </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'

export default {
  computed: {
    ...mapState('youtubeClaims', [
      'claimsPrivate',
      'loading',
      'order_column',
      'order_type',
      'page',
      'page_size',
    ])
  },

  methods: {
    ...mapMutations('youtubeClaims', [
      'setPage',
      'setPageSize',
      'setOrdering'
    ]),
    ...mapActions('youtubeClaims', [
      'readClaims'
    ]),
    release(row) {
      row.other.forEach(e => {
        this.releaseClaim(e.claimId)
      })
    },
    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.readClaims('Private')
    },
    currentChange(currentPage) {
      this.setPage(currentPage)
      this.readClaims('Private')
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.readClaims('Private')
    },
  }
}
</script>
]
